export enum MessengerOnboardingSteps {
  Token = 'token',
  Groups = 'groups',
  Messages = 'messages',
}
